import { Skeleton } from 'ui/skeleton';

interface Props {
  count?: number;
}

export default function InfoCardSkeleton({ count = 4 }: Props) {
  return (
    <div className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-4">
      {Array.from({ length: count }).map((_, index) => (
        <div key={index} className="relative rounded-sm border border-empty-border bg-card py-3 pl-4 pr-11">
          {/* top-right icon */}
          <Skeleton className="absolute top-0 right-0 h-7 w-7 rounded-bl-sm rounded-tr-xs" />

          <div className="flex flex-col gap-4">
            <div className="flex justify-between">
              <Skeleton className="h-4 w-28" />
              <Skeleton className="h-3 w-10" />
            </div>

            <div className="flex items-end gap-1">
              <Skeleton className="h-10 w-32" />
              <Skeleton className="h-5 w-6" />
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
